module.exports = __webpack_public_path__ + "static/media/ZEN-2.0e904789.png";